<template>
    <div class="details_body">
        <ul class="details_tab">
            <li @click="num = 0" :class="{active: num == 0}">myTrader介绍</li>
            <li @click="num = 1" :class="{active: num == 1}">功能介绍</li>
            <li @click="num = 2" :class="{active: num == 2}">购买须知</li>
            <!-- <li @click="num = 3" :class="{active: num == 3}">服务介绍</li> -->
        </ul>
        <div class="details_gn" style='font-size:14px;color:#6f6f6f;' v-show="num == 0">
            myTrader是赢顺<common-data name="appShortName_10"/>的英文版软件，是一款智能化的交易软件，集行情、分析、下单于一身，操作特点追求简洁、高速、方便，英文版软件对于境外投资者更是交易利器。
            <div class="tips">安全提示：交易过程中请勿点击不明来源的链接，付款前请务必详细核对支付信息</div>
        </div>
        <div class="details_gn" v-show="num == 1">
            <p>1.可以通过中国的130多家期货公司交易中国原油；</p>
            <p>2.全市场数据，提供国内外期货、黄金、外汇、股票市场行情；</p>
            <p>3.可选配境外CME、LME等实时数据；</p>
            <p>4.强大的图表分析功能，包括自定义周期、画线、自编指标、画线预警、公式预警等；</p>
            <p>5.便捷交易，三键下单界面开、平独立分区，简化下单思考步骤；</p>
            <p>6.云端交易，支持云端条件单、损盈单、画线下单；</p>
            <p>7.账户风控，电脑监控账户资金、盈亏、权益、资金使用率等，达到设定条件自动平仓。</p>
            <div class="tips">安全提示：交易过程中请勿点击不明来源的链接，付款前请务必详细核对支付信息</div>
        </div>
        <div class="details_gn" v-show="num == 2">
            <!-- <p class="tent">1.购买前请先下载<a href="https://en.wenhua.com.cn/#trial" target="_blank">myTrader(wh6赢顺英文版)</a>模拟软件体验功能。</p> -->
            <p class="tent">
                2.使用myTrader软件的电脑配置要求：<br />
                · 最低2G内存；<br />
                · CPU要达到双核及以上；<br />
                · 操作系统win7、win10；
            </p>
            <p class="tent">3.推荐南方地区使用电信网络；北方地区使用联通网络，其它网络使用效果不佳。</p>
            <p class="tent">4.使用授权账号登录后可选择文华支持的任意期货公司进行交易（<a href="https://www.wenhua.com.cn/Home/Partner" target="_blank">查看文华支持的期货公司名单</a>），但如以后因所开户的期货公司交易通道关闭，文华不负责解决并不退还剩余费用。</p>
            <div class="tips">安全提示：交易过程中请勿点击不明来源的链接，付款前请务必详细核对支付信息</div>
        </div>
        <div class="details_gn" v-show="num == 3"></div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                num: 2
            }
        },
    }
</script>
<style scoped>
@import url('./doc.css');
    .details_gn{
        min-height: 185px;
    }
</style>